var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshare = function SvgScreenshare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.846 6.221c-.573-.544-1.519-.137-1.519.653V8.6c-4.698.322-8.48 3.639-8.805 7.847a.886.886 0 0 0 .62.919.9.9 0 0 0 1.011-.347c2.185-3.14 5.332-3.882 7.174-3.974V15.2c0 .799.962 1.202 1.531.642l4.308-4.24a.9.9 0 0 0-.012-1.295zm-.019 3.854V8.27l2.844 2.698-2.844 2.8v-2.195l-.718-.03c-1.526-.066-4.68.256-7.371 2.589 1.255-2.348 4-4.057 7.339-4.057z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3a3 3 0 0 0-3 3v11.25a3 3 0 0 0 3 3h.75a.75.75 0 0 0 0 1.5h13.5a.75.75 0 0 0 0-1.5h.75a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm15 1.5h-15A1.5 1.5 0 0 0 3 6v11.25a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5",
    clipRule: "evenodd"
  })));
};
export default SvgScreenshare;